import React from 'react';
import { cn } from '@/lib/utils';
import { useTranslation } from 'react-i18next';
import { Pickaxe, Factory, Building2, Wrench, Briefcase, HelpCircle } from 'lucide-react';

interface SectorBadgeProps {
  sector: 'mining' | 'processing' | 'infrastructure' | 'industrial' | 'services' | 'other';
  className?: string;
  showIcon?: boolean;
}

const sectorIcons = {
  mining: Pickaxe,
  processing: Factory,
  infrastructure: Building2,
  industrial: Wrench,
  services: Briefcase,
  other: HelpCircle,
};

export const SectorBadge = React.forwardRef<HTMLSpanElement, SectorBadgeProps>(({ sector, className, showIcon = true }, ref) => {
  const { t } = useTranslation();
  const Icon = sectorIcons[sector];

  return (
    <span
      ref={ref}
      className={cn(
        'inline-flex items-center gap-1.5 rounded-full bg-muted px-2.5 py-1 text-xs font-medium text-muted-foreground',
        className
      )}
    >
      {showIcon && <Icon className="h-3 w-3" />}
      {t(`sectors.${sector}`)}
    </span>
  );
});

SectorBadge.displayName = 'SectorBadge';